import { useState, useEffect } from 'react';
import loadMarkdown from './loadMarkdown';
import { useSiteContext } from '../components/SiteContext';

const useMarkdownLoader = (
  markdownImports: Record<string, () => Promise<{ default: string }>>,
) => {
  const { locale } = useSiteContext();
  const [markdown, setMarkdown] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarkdown = async () => {
      const content = await loadMarkdown(locale, markdownImports);
      setMarkdown(content);
      setLoading(false);
    };

    fetchMarkdown();
  }, [locale, markdownImports]);

  return { markdown, loading };
};

export default useMarkdownLoader;
